import * as React from "react";
const SvgZapOff = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.269 2.269a1.034 1.034 0 0 1 1.462 0L8.73 7.266l.018.018 7.982 7.982.018.018 4.984 4.985a1.034 1.034 0 1 1-1.462 1.463l-4.2-4.2-4.274 5.13a1.035 1.035 0 0 1-1.822-.79l.854-6.837H4.708c-.252 0-.512 0-.724-.018-.19-.018-.56-.063-.881-.323a1.54 1.54 0 0 1-.57-1.217l.01-.15c.045-.34.21-.597.306-.734.12-.175.289-.374.45-.568l3.3-3.962L2.27 3.73a1.034 1.034 0 0 1 0-1.462m10.196 16.356 2.135-2.562-1.614-1.614zm6.827-9.66c.252 0 .512 0 .724.018.166.015.47.053.758.236l.123.087.13.118c.286.29.447.687.44 1.1-.005.413-.207.726-.316.883-.12.175-.289.374-.45.568l-1.355 1.627a1.035 1.035 0 0 1-1.591-1.325l1.035-1.242h-3.14a1.035 1.035 0 0 1 0-2.07zm-14.082 4h6.292L8.069 9.532zm6.995-11.627a1.035 1.035 0 0 1 1.822.79l-.6 4.798a1.036 1.036 0 0 1-2.054-.257l.161-1.294-.166.2a1.036 1.036 0 0 1-1.59-1.325z"
}));
export default SvgZapOff;
//# sourceMappingURL=ZapOff.js.map